<template>
  <div class="confirm-stage" :class="{ active: formSectionComplete }">
    <div class="d-title">
      <span class="lbl-cap8 text-bold">{{ number }}. Selected Coupon</span>
      <div class="action-edit" @click="gotoEdit(1)" v-if="formSectionComplete">
        Edit
      </div>
    </div>
    <div class="d-detail" v-if="formSectionComplete">
      <div class="lbl-cap6 text-cap">
        <span>
          {{ selectedCoupon().offer_red_text.toLowerCase() }}
          {{ selectedCoupon().offer_text_top.toLowerCase() }}
          {{ selectedCoupon().offer_subline.toLowerCase() }}
        </span>
      </div>
      <div class="off-site-btn-area" v-if="user.off_site">
        <div class="off-site-btn">Off-Site Visit</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "formCouponReview",
  props: {
    number: Number,
  },
  mounted: function () {},
  computed: {
    section() {
      return this.$store.state.components.appointment.steps[1];
    },
    user() {
      return this.$store.state.user;
    },
    formStore() {
      return this.$store.state.user.services;
    },
    formSectionComplete() {
      return this.$store.getters.formCoupons;
    },
  },
  methods: {
    selectedCoupon() {
      return this.$store.state.coupons.selectedCoupon;
    },
    userStore() {
      return this.$store.getters.formStore;
    },

    gotoEdit: function (index) {
      this.$emit("goToEdit", index);
    },
  },
};
</script>
